module.exports = __webpack_public_path__ + "img/008.4d4e487a.png";